import { _ } from "../../../polyglot/polyglot.js";
import { periodSectionRenderer } from "./popoverPeriodSectionBuilder.js";
import makeInputValuePopover from "./makeInputValuePopover.js";

/**
 * Create a popover that shows when clicking on a period input value.
 *
 * @param {function} getPeriod - Function returning the base period used to fetch data
 * @param {bool} isBimesterEnabled - When true, the period type dropdown shows Bimester
 * @param {PeriodType} defaultPeriodType - Period type used by default
 * @param {function} updateNodeAttributes - Function used to update a ProseMirror node attributes
 * @param {function():DOMElement} getTriggerItem - Returns the element
 *   that will trigger the popover on click
 * @param {object} content - Value fetched by the input value
 * @param {number} content.shift - Number of period shifts
 * @param {PeriodType} content.shiftPeriodType - Type of period shift
 */
export default function makePeriodInputValuePopover({
	getPeriod,
	isBimesterEnabled,
	defaultPeriodType,
	updateNodeAttributes,
	getTriggerItem,
	content: { shift, shiftPeriodType },
}) {
	const popover = makeInputValuePopover({
		triggerItem: getTriggerItem(),
		header: (html) => {
			html.span(html.strong(getPeriod().toSmartString()));
		},
		content: (html) => {
			html.div(
				html.div(
					{ class: "description" },
					_("Period of the period report"),
				),
				periodSectionRenderer({
					isBimesterEnabled,
					shift,
					shiftPeriodType,
					updateNodeAttributes,
					defaultPeriodType,
					canShift: !getPeriod().isConsecutiveMonths(),
					onChange: () => popover.setTriggerItem(getTriggerItem()),
				}),
			);
		},
	});
}
